import React from 'react';
import PropTypes from 'prop-types';
import './GroupParentDisplay.scss';

const renderAnswer = (answer, index) => {
  if (answer.value) {
    switch (answer.question_type) {
      case 'select_one':
        if (answer.style === 'multiselect') {
          return (
            <span key={`${answer.question_type}-field-${index}`} className={`field-${index} ${answer.question_type} ${answer.style}`}>
              {answer.question_key === 'languages_language_id' && <i className="fa fa-globe-americas" />}
              {answer.value.label}
            </span>
          );
        }
        break;
      case 'freetext':
      case 'location':
      case 'year':
      case 'number':
        return (
          <span key={`${answer.question_type}-field-${index}`} className={`field-${index} ${answer.question_type} ${answer.style}`}>
            {answer.value}
          </span>
        );
      case 'date':
        return (
          <span key={`${answer.question_type}-field-${index}`} className={`field-${index} ${answer.question_type} ${answer.style}`}>
            {window.moment(answer.value).format('LL')}
          </span>
        );
      default:
        return null;
    }
  }

  return null;
};

function GroupParentDisplay({ answers, questionKey }) {
  return (
    <div key={questionKey} className="group-parents">
      {answers.map((answer, index) => (
        <div
          key={`group-parent-display-${index}`}
          className={`group-parent-display group-parent-display-${index} ${questionKey}`}
        >
          {answer.map((a, i) => renderAnswer(a, i))}
        </div>
      ))}
    </div>
  );
}

GroupParentDisplay.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  questionKey: PropTypes.string.isRequired,
};

export default GroupParentDisplay;
